import React, { useContext, memo } from 'react';

import FormModalContext from '../../context/FormModalContext';
import { ContactForm } from '.';
import { ContactFormModal } from './ContactFormModal';

const Form = ({
  contactForm,
  noForm,
  contactUs = false,
  formImages,
  location,
  pardotUrl,
  pricingDesktop,
  fullWidthForm = false,
  slideUp,
  wavelytics,
  quizLogo,
  quizIntro,
}) => {
  const { formModalOpen, setFormModalOpen } = useContext(FormModalContext);

  const MemoizedForm = memo(ContactForm);
  const MemoizedModal = memo(ContactFormModal);

  return (
    <>
      {!formModalOpen ? (
        <MemoizedForm
          contactForm={contactForm}
          privacy
          modal={false}
          open={formModalOpen}
          // callback={callback}
          noForm={noForm}
          contactUs={contactUs}
          formImages={formImages}
          location={location}
          pardotUrl={pardotUrl}
          pricingDesktop={pricingDesktop}
          fullWidthForm={fullWidthForm}
          slideUp={slideUp}
          wavelytics={wavelytics}
          quizLogo={quizLogo}
          quizIntro={quizIntro}
        />
      ) : (
        <MemoizedModal
          open={formModalOpen}
          toggleOpen={setFormModalOpen}
          contactForm={contactForm}
          // callback={callback}
          noForm={noForm}
          formImages={formImages}
          modal
          location={location}
          pardotUrl={pardotUrl}
          fullWidthForm={fullWidthForm}
          wavelytics={wavelytics}
          quizLogo={quizLogo}
          quizIntro={quizIntro}
        />
      )}
    </>
  );
};

export default Form;
